// @flow

import React from 'react';
import styled from 'styled-components';
import Link from 'react-router-dom/Link';

import logoSrc from './logo.png';

const Root = styled(Link)`
  position: absolute;
  left: 30px;
  top: 3px;
  bottom: 3px;

  display: flex;
  align-items: center;

  text-decoration: none;

  color: #fcfcfc;
`

function Logo() {
  return (
    <Root to="/">
      <img
        width="116"
        height="44"
        src={logoSrc}
        alt="Bosti"
      />
    </Root>
  );
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Header/Logo/Logo.js